var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C9.12813 0 6.82812 0.71875 4.8875 2.08438C3.01875 3.37812 1.58125 5.24688 0.71875 7.40313L0.503125 7.97813H3.01875L3.09063 7.69062C3.52188 6.68437 4.16875 5.82188 4.95937 5.03125C6.68438 3.30625 8.98438 2.37188 11.4281 2.37188C13.8719 2.37188 16.1719 3.30625 17.8969 5.03125C19.6219 6.75625 20.5562 9.05625 20.5562 11.5C20.5562 13.9438 19.6219 16.2437 17.8969 17.9688C16.1719 19.6938 13.8719 20.6281 11.4281 20.6281C8.98438 20.6281 6.68438 19.6938 4.95937 17.9688C4.16875 17.1781 3.59375 16.3156 3.09063 15.3094L3.01875 15.0219H0.503125L0.71875 15.5969C1.50937 17.7531 2.94688 19.55 4.8875 20.9156C6.82812 22.2812 9.12813 23 11.5 23C17.825 23 23 17.825 23 11.5C23 5.175 17.825 0 11.5 0ZM0 12.65H10.4938L8.05 15.0938L9.70312 16.7469L15.0219 11.4281L9.70312 6.10938L7.97813 7.7625L10.4219 10.2063H0V12.65Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.86ee908d4d821583d59367484bc78f4c.svg";
export { ForwardRef as ReactComponent };